import React, { useEffect, useState } from 'react';
import { useParams  } from "react-router-dom";
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import StoreInfo from '../../parts/StoreInfo';
import { getApiData } from '../../../services/apiService';
import { serviceRequestData } from '../../../services/serviceHubStore';
import { data } from 'jquery';

export default function ServiceRequestPrintAcceptanceView (){
    const { service_request_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState(serviceRequestData);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [load_status, setStatus] = useState(0);
   
    useEffect(() => {
        initTreeView()
        if(service_request_id){
            fetchData(service_request_id)
        }
    }, []);

    useEffect(() => {
        if(load_status){
            setTimeout(function(){
                window.print()
            }, 2000);
        }
    }, [load_status]);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);


    async function fetchData(service_request_id){
        if(!service_request_id){
            return
        }

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/${service_request_id}`)
        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            setRecordData(res)
            setRecordItems(res.items)
        }
                
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/polarserv/service-requests/list");
                }
            })
        }
    }

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                    <>
                    <tr>
                        <td rowSpan={2}>{data.qr_code}</td>
                        <td>{data.brand}</td>
                        <td>{data.serial_no}</td>
                        <td>{data.unit_location ? data.unit_location : 'N/A'}</td>
                        <td>
                            <b>Complaint:</b> {data.complaint ? data.complaint : 'N/A'}<br/>
                            <b>Assessment:</b> {data.assessment ? data.assessment : 'N/A'}<br/>
                            <b>Recommendation:</b> {data.recommendation ? data.recommendation : 'N/A'}
                        </td>
                    </tr>
                    
                        <tr>
                            <td colSpan={4}>
                                <p className='mb-1 font-weight-bold'>Required Parts: </p>
                                
                                {
                                data?.required_parts.length ?
                                <table className='table table-sm mb-0 border-none'>
                                    <thead>
                                        <tr>
                                            <th>Item Description</th>
                                            <th>Quantity</th>
                                            <th>Unit Amount</th>
                                            <th>Total</th>
                                            <th>Parts Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.required_parts.map((item, index) => (
                                            <tr>
                                                <td>{item.item_description}</td>
                                                <td>{item.quantity}</td>
                                                <td>{helpers.formatCurrencyAmount(item.unit_price)}</td>
                                                <td>{helpers.formatCurrencyAmount(parseFloat(item.unit_price) * item.quantity)}</td>
                                                <td>{item.status}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table> : 'N/A' 
                                }
                            </td>
                        </tr>
                    </>
                )
            })
        }
        else{
            items =  
                    <tr>
                        <td colSpan={5} className='text-center'>No data to display.</td>
                    </tr>
        }

        setTableItems(<tbody>{items}</tbody>)
        setStatus(1)
    }

    function computeSubTotals(){
        let items = 0;
        let total_amount = 0
        Object.entries(record_items).map(([key, data]) => {
            items = items + Number(data.quantity)
            total_amount = total_amount + parseInt(data.quantity) * parseFloat(data.amount)
        });

        return helpers.formatCurrencyAmount(total_amount);
    }


    return (
        <div className="invoice p-4 mb-3">
            <Loader isLoading={loading}/>
            <div className="d-flex justify-content-between mb-3">
                <div>
                    <img src={images.main_logo} height={120} />
                </div>

                <div className='text-right'>
                    <h4><strong>SERVICE ACCEPTANCE</strong></h4>
                    {/* <h5>{helpers.displayOrderStatusBadge(record_data.order_status_id, record_data.order_status)}</h5> */}
                    <h5 className='mb-0'>{record_data.service_no ? `Service No: ${record_data.service_no}` : 'N/A'}</h5>
                </div>
            </div>

            <div className="row">
                <div className="col-4 mb-3">
                    <div>
                        <p className='mb-0'><b>Polar-Air Aircon</b></p>
                        <p className='mb-0'>Matias Building, National Highway, Isulan, Sultan Kudarat 9805</p>
                        <p className='mb-0'>0953-685-7478</p>
                    </div>
                </div>
                <div className="col-4 mb-3">
                    <h5 className='mb-0'><b>To:</b></h5>
                    <div>
                        <p className='mb-0'><b>{record_data.customer_name}</b></p>
                        <p className='mb-0'>{helpers.concatenateText([record_data.address_1, record_data.address_2, record_data.city, record_data.province], ', ')}</p>
                        <p className='mb-0'>{record_data.phone_no ? record_data.phone_no : 'N/A'}</p>
                    </div>
                </div>
                <div className="col-4 text-lg-right mb-2">
                    <table className='table table-borderless table-sm'>
                        <tbody>
                            <tr>
                                <td className='py-0'><b>Date:</b></td>
                                <td className='py-0'>{helpers.formatDate(record_data.received_date)}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Service Type:</b></td>
                                <td className='py-0'>{helpers.concatenateText([record_data?.service_type_name, record_data?.sub_service_type_name], ' > ')}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Technician(s):</b></td>
                                <td className='py-0'>{record_data?.member_names?.length ? helpers.concatenateText(record_data.member_names, ', ') : 'N/A'}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Labor Fee:</b></td>
                                <td className='py-0'>{record_data.labor_fee ? helpers.formatCurrencyAmount(record_data.labor_fee) : 'N/A'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row mb-3">
                {
                    record_data?.assessment ?
                    <div className='col-12'>
                        Remarks: {record_data.remarks ? record_data.remarks : 'N/A'}
                    </div> : ''
                }
                {
                    record_data?.assessment ?
                    <div className='col-12'>
                        General Asessment: {record_data.assessment ? record_data.assessment : 'N/A'}
                    </div> : ''
                }
                {
                    record_data?.recommendation ?
                    <div className='col-12'>
                        General Recommendation: {record_data.recommendation ? record_data.recommendation : 'N/A'}
                    </div> : ''
                }
                {
                    record_data?.recommendation ?
                    <div className='col-12'>
                        Acceptance Remarks: {record_data.acceptance_remarks ? record_data.acceptance_remarks : 'N/A'}
                    </div> : ''
                }
            </div>

            <div className='table-responsive'>
                <table className='table table-bordered table-stripeds table-sm border-bottom'>
                    <thead class="thead-dark">
                        <tr>
                            <th>QR CODE</th>
                            <th>BRAND</th>
                            <th>SERIAL NO</th>
                            <th>UNIT LOCATION</th>
                            <th></th>
                        </tr>
                    </thead>
                    {
                        table_items
                    }
                </table>
            </div>

            <div className="row mt-3">
                <div className="col-5">
                    <div className="cards">
                        <table className='table border-0 mb-0'>
                            <tr>
                                <td className='border-top-0 text-center'>
                                    <div><img src={record_data.receiver_signature} style={{maxWidth: '150px'}} alt="signature"/></div>
                                    {record_data.receiver_name}
                                </td>
                            </tr>
                            <tr>
                                <td className='text-center print-border-top'>Customer’s Signature Over Printed Name</td>
                            </tr>
                        </table>
                    </div>
                </div>
                {/* <div className="col-1"></div>
                <div className="col-3">
                    <div className="cards">
                        <table className='table table-large'>
                            <tr>
                                <td className='border-top-0 text-center'>{record_data.received_date}</td>
                            </tr>
                            <tr>
                                <td className='text-center print-border-top'>Date</td>
                            </tr>
                        </table>
                    </div>
                </div> */}
            </div>

            {/* <div className="row mt-3">
                <div className="col-4">
                    <div className="cards">
                        <table className='table border-0'>
                            <tr>
                                <td className='border-top-0'>&nbsp;</td>
                            </tr>
                            <tr>
                                <td className='text-center print-border-top'>Technician’s Signature Over Printed Name</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div className="col-1"></div>
                <div className="col-3">
                    <div className="cards">
                        <table className='table table-large'>
                            <tr>
                                <td className='border-top-0'>&nbsp;</td>
                            </tr>
                            <tr>
                                <td className='text-center print-border-top'>Date</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12" style={{fontSize: '12px'}}>
                    <strong>Terms and Conditions:</strong> <br/>
                    <strong>Fees:</strong> The customer agrees to pay for all parts and labor as outlined in the Repairs Details Above.<br/>
                    <strong>Right to Refuse Repair:</strong> Polar-Air Aircon reserves the right to refuse service to any customer at its sole discretion. <br/>
                    <strong>Changes to Repair Cost:</strong> Polar-Air Aircon reserves the right to change the price of parts and labor as necessary and will provide the customer with a revised estimate if this occurs. <br/>
                    <strong>Cancellation Fee:</strong> If the customer cancels the repair order after Polar-Air Aircon has ordered parts for the repair work, customer agrees to pay cancellation fee equivalent to 30% of the parts and any other expenses incurred by the Polar-Air Aircon in connection with the repair work. <br/>
                    <strong>Liability:</strong> The customer agrees to indemnify and hold Polar-Air Aircon harmless from any and all claims, damages, or expenses that may arise as a result of the repair work. <br/>
                    <strong>Warranty:</strong> Polar-Air Aircon provides a 30 days labor warranty if same defects detailed in Repair Details above occur. <br/>
                    <strong>Out of Warranty:</strong> The warranty does not cover any defects in the repair work that arise due to misuse or neglect of the appliance or any issues reported that is unrelated to the defect as detailed in the Repair Details Above. <br/>
                    <strong>Void of Warranty:</strong> If the appliance is found to be damaged or not repairable due to misuse or neglect, the warranty will be voided and the customer will be responsible for all repair costs. <br/>
                    <strong>Storage Fee:</strong> If the customer is unable to retrieve their appliance within 7 days of the repair being completed and being notified by JMA Electornics, a storage fee of Php20 per day will be applied for each unit that the appliance remains in the possession of Polar-Air Aircon. <br/>
                    <strong>Customer Notification:</strong> Polar-Air Aircon will make reasonable efforts to contact the customer to arrange for retrieval of the appliance but is not responsible for any damages or loss that may occur due to the appliance being in storage. <br/>
                    <strong>Release of Units:</strong> The customer is responsible for paying all storage fees in full before the appliance will be released. <br/>
                    <strong>Disposal of Unclaimed Units:</strong> Polar-Air Aircon reserves the right to dispose of the appliance if it remains in storage for 60 days and all storage fees have not been paid. <br/>
                    The customer agrees to these terms and conditions by signing and submitting the job order form.
                </div>
            </div> */}

            <div className="row border-top mt-5">
                <div className="col-12 text-center">
                    <small>Powered By Topventory Sales &amp; Inventory Solutions</small>
                </div>
            </div>
        </div>
    )
}